// https://it.wikipedia.org/wiki/ISO_639
// ftp://ftp.fu-berlin.de/doc/iso/iso3166-countrycodes.txt
export default {
  en_au: {
    intl: 'en-AU',
  },
  en_nz: {
    intl: 'en-NZ',
  },
  en_us: {
    intl: 'en-US',
  },
  en_za: {
    intl: 'en-ZA',
  },
  es_ar: {
    intl: 'es-AR',
  },
  es_cl: {
    intl: 'es-CL',
  },
  es_co: {
    intl: 'es-CO',
  },
  es_ec: {
    intl: 'es-EC',
  },
  es_es: {
    intl: 'es',
  },
  es_mx: {
    intl: 'es-MX',
  },
  fr_fr: {
    intl: 'fr',
  },
  id_id: {
    intl: 'id',
  },
  it_it: {
    intl: 'it',
  },
  pt_br: {
    intl: 'br',
  },
  pt_pt: {
    intl: 'pt-PT',
  },
};
